export enum TooltipTypes {
  Description = 'description',
  Label = 'label'
}
